import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ThemeSwitcher from '../components/ThemeSwitcher';
import { usePage } from '../hooks/usePage';

import { adminLogin, clearAuthError, userLogin } from '../store/slices/auth';

const BODY_CLASS = "bg-slate-950 text-slate-100 min-h-screen flex flex-col justify-between font-sans selection:bg-blue-600 selection:text-white";

const TAB_BASE = 'py-3 px-2 rounded-xl transition flex flex-col sm:flex-row items-center justify-center gap-2 ';
const TAB_ACTIVE = {
  ADMIN: 'bg-gradient-to-r from-amber-600 to-yellow-600 text-slate-950 font-black shadow-lg cursor-pointer',
  COMMANDER: 'bg-indigo-600 text-white font-bold shadow-lg cursor-pointer',
};
const TAB_IDLE = 'text-slate-400 hover:text-white cursor-pointer';

// Target pages run live map controllers, so they are opened with a full navigation.
const go = (url) => window.location.assign(url);

export default function Login() {
  usePage({ title: 'Command & Officer Authentication - Election Police Live Tracking', bodyClass: BODY_CLASS });

  const [portal, setPortal] = useState('ADMIN');

  // Admin credentials
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  // Commander credentials
  const [commanderUserId, setCommanderUserId] = useState('');
  const [commanderPassword, setCommanderPassword] = useState('');

  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);
  // Drop any stale error from a previous visit, and when switching tabs.
  useEffect(() => {
    dispatch(clearAuthError());
  }, [dispatch, portal]);

  const tabClass = (key) => TAB_BASE + (portal === key ? TAB_ACTIVE[key] : TAB_IDLE);

  async function handleAdminLoginSubmit(event) {
    event.preventDefault();
    if (loading) return;
    const result = await dispatch(adminLogin({ username: username.trim(), password }));
    if (adminLogin.fulfilled.match(result)) {
      go('/admin');
    }
  }
  async function handleCommanderLoginSubmit(event) {
    event.preventDefault();

    if (loading) return;

    const result = await dispatch(
      userLogin({
        userId: commanderUserId.trim().toUpperCase(),
        password: commanderPassword,
      })
    );

    // if (userLogin.fulfilled.match(result)) {
    //   go('/admin');
    // }
  }



  return (
    <>

      <header className="py-3.5 px-6 border-b border-slate-800 bg-slate-900/80 backdrop-blur-md flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-tr from-blue-700 via-indigo-600 to-blue-500 flex items-center justify-center text-white shadow-lg text-xl font-black">
            🇮🇳
          </div>
          <div>
            <h1 className="text-sm font-black tracking-tight text-white uppercase flex items-center gap-2">
              <span>
                Nellore Police
              </span>

            </h1>

          </div>
        </div>
        <div className="flex items-center gap-3">
          {/* Pleasant Theme Switcher */}
          <ThemeSwitcher labelClass="hidden sm:inline" />
          <button onClick={(event) => { openApkModal() }} className="px-2.5 py-1 rounded-full text-[11px] font-bold bg-emerald-600/20 text-emerald-400 border border-emerald-500/40 hover:bg-emerald-600 hover:text-white transition flex items-center gap-1">
            <span>
              📲
            </span>
            {' '}Staff App APK
          </button>
          <a href="/emergency-sos" className="px-2.5 py-1 rounded-full text-[11px] font-bold bg-red-600/20 text-red-400 border border-red-500/40 hover:bg-red-600 hover:text-white transition flex items-center gap-1">
            <span>
              🚨
            </span>
            {' '}Incident Grid
          </a>
          <span className="hidden md:inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-bold bg-emerald-500/10 text-emerald-400 border border-emerald-500/30">
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
            {' '}1,520 STATIONS SECURED
          </span>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center p-4 sm:p-6 lg:p-8">
        <div className="w-full max-w-4xl bg-slate-900 border border-slate-800 rounded-3xl p-6 sm:p-8 shadow-2xl relative overflow-hidden">
          {/* Ambient Glow Behind Card */}
          <div className="absolute -top-32 -left-32 w-64 h-64 bg-amber-600/15 rounded-full blur-3xl pointer-events-none"></div>
          <div className="absolute -bottom-32 -right-32 w-64 h-64 bg-blue-600/15 rounded-full blur-3xl pointer-events-none"></div>
          <div className="relative z-10">
            <div className="text-center mb-6">
              <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-slate-950 border border-slate-800 text-[11px] text-amber-300 font-bold mb-2">
                <span>
                  🛡️
                </span>
                {' '}Multi-Tier Hierarchical Command & Below-Staff Monitoring Access
              </div>
              <h2 className="text-2xl font-black text-white tracking-tight">
                Official Identity Authentication
              </h2>

            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 bg-slate-950 p-1.5 rounded-2xl border border-slate-800 mb-6 text-xs font-bold">

              <button id="tab-admin" onClick={() => setPortal('ADMIN')} className={tabClass('ADMIN')}>
                <span className="text-base">
                  👑
                </span>
                <span className="text-center sm:text-left">
                  <span className="block text-xs font-black">
                    District Admin
                  </span>
                  <span className="block text-[9px] opacity-80 font-bold">
                    SP Full District
                  </span>
                </span>
              </button>
              <button id="tab-commander" onClick={() => setPortal('COMMANDER')} className={tabClass('COMMANDER')}>
                <span className="text-base">
                  🚔
                </span>
                <span className="text-center sm:text-left">
                  <span className="block text-xs font-bold">
                    Commanders
                  </span>
                  <span className="block text-[9px] opacity-75">
                    DSP, CI, SI, ASI & Wings
                  </span>
                </span>
              </button>

            </div>


            {portal === 'ADMIN' && (
              <div id="portal-admin" className="space-y-5">

                <form onSubmit={handleAdminLoginSubmit} className="space-y-4">

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div>
                      <label htmlFor="admin-user" className="block text-xs font-semibold text-slate-300 mb-1">
                        Command Room Username:
                      </label>
                      <input type="text" id="admin-user" name="username" autoComplete="username" value={username} onChange={(e) => setUsername(e.target.value)} required disabled={loading} className="w-full bg-slate-950 border border-slate-700 rounded-xl p-3 text-xs text-white focus:outline-none focus:border-amber-500 disabled:opacity-60" />
                    </div>
                    <div>
                      <label htmlFor="admin-pass" className="block text-xs font-semibold text-slate-300 mb-1">
                        Master Access Password / PIN:
                      </label>
                      <input type="password" id="admin-pass" name="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required disabled={loading} className="w-full bg-slate-950 border border-slate-700 rounded-xl p-3 text-xs text-white focus:outline-none focus:border-amber-500 disabled:opacity-60" />
                    </div>
                  </div>
                  {error && (
                    <div id="admin-error" role="alert" className="rounded-xl border border-red-500/40 bg-red-950/50 px-3 py-2 text-xs font-semibold text-red-300">
                      {error}
                    </div>
                  )}
                  <button type="submit" disabled={loading} className="w-full py-3.5 bg-gradient-to-r from-amber-600 via-amber-500 to-yellow-500 hover:from-amber-500 hover:to-yellow-400 text-slate-950 font-black rounded-xl text-xs shadow-xl shadow-amber-950/60 transition flex items-center justify-center gap-2 cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed">
                    <span>
                      🛡️
                    </span>
                    <span>
                      {loading ? 'Signing in…' : 'Login →'}
                    </span>
                  </button>
                </form>
              </div>
            )}

            {portal === 'COMMANDER' && (
              <div id="portal-commander" className="space-y-5">
                <form
                  onSubmit={handleCommanderLoginSubmit}
                  className="space-y-4"
                >
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div>
                      <label
                        htmlFor="commander-userid"
                        className="block text-xs font-semibold text-slate-300 mb-1"
                      >
                        Officer User ID:
                      </label>

                      <input
                        type="text"
                        id="commander-userid"
                        value={commanderUserId}
                        onChange={(e) => setCommanderUserId(e.target.value)}
                        placeholder="Enter Officer ID"
                        required
                        disabled={loading}
                        className="w-full bg-slate-950 border border-slate-700 rounded-xl p-3 text-xs text-white focus:outline-none focus:border-indigo-500 disabled:opacity-60"
                      />
                    </div>

                    <div>
                      <label
                        htmlFor="commander-password"
                        className="block text-xs font-semibold text-slate-300 mb-1"
                      >
                        Password:
                      </label>

                      <input
                        type="password"
                        id="commander-password"
                        value={commanderPassword}
                        onChange={(e) => setCommanderPassword(e.target.value)}
                        placeholder="Enter Password"
                        required
                        disabled={loading}
                        className="w-full bg-slate-950 border border-slate-700 rounded-xl p-3 text-xs text-white focus:outline-none focus:border-indigo-500 disabled:opacity-60"
                      />
                    </div>
                  </div>

                  {error && (
                    <div
                      role="alert"
                      className="rounded-xl border border-red-500/40 bg-red-950/50 px-3 py-2 text-xs font-semibold text-red-300"
                    >
                      {error}
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full py-3 bg-indigo-600 hover:bg-indigo-500 text-white font-bold rounded-xl text-xs shadow-lg transition flex items-center justify-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
                  >
                    {loading ? 'Signing in...' : 'Launch Scoped Command Center →'}
                  </button>
                </form>
              </div>
            )}


            {/* STAFF APP APK DOWNLOAD BOX */}
            <div className="mt-5 p-4 rounded-2xl bg-gradient-to-r from-emerald-950/60 via-slate-900 to-indigo-950/60 border border-emerald-500/40 text-center">
              <div className="flex items-center justify-center gap-2 mb-1.5">
                <span className="text-xl">
                  📲
                </span>
                <span className="text-xs font-black text-emerald-300 uppercase tracking-wider">
                  Field Police Android App (.apk)
                </span>
              </div>
              <p className="text-[11px] text-slate-300 mb-3 leading-relaxed">
                Police officers can install the official{' '}
                <strong>
                  Election Duty Tracker APK
                </strong>
                {' '}on their Android device for continuous 24h background GPS tracking, or log in directly via mobile browser.
              </p>
              <div className="flex flex-col sm:flex-row gap-2 justify-center">
                <button type="button" onClick={(event) => { openApkModal() }} className="px-4 py-2 bg-emerald-600 hover:bg-emerald-500 text-white rounded-xl text-xs font-black shadow-lg shadow-emerald-900/50 flex items-center justify-center gap-1.5 transition">
                  <span>
                    📥
                  </span>
                  {' '}Download Staff APK
                </button>

              </div>
            </div>
          </div>
        </div>
      </main>
      {/* FOOTER */}
      <footer className="py-3 px-6 border-t border-slate-800 text-center text-xs text-slate-500">
        Election Police Live Location Tracking Platform • Automated Geofencing, Subordinate Scoping & Emergency SOS Dispatch
      </footer>
      {/* SCRIPTS */}
    </>
  );
}
